<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
html {
  margin: 0px;
  height: 100%;

  body {
    height: 100%;
    margin: 0px;
    font-family: Open Sans, sans-serif;
    color: #545454;
    h2 {
      text-align: left;
      font-size: 25px;
    }
    p {
      text-align: left;
      max-width: 650px;
      line-height: 1.6;
      font-size: 14px;
      color: #545454;
    }
    .line {
      width: 100%;
      height: 1px;
      background: #cfcfd2;
      margin: 15px auto;
    }
  }
}
</style>
